import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { PacmanLoader } from "react-spinners";
import { login } from "../features/auth/authSlice";
import { toast } from "react-toastify";

function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const accessToken = params.get("accessToken");

    if (accessToken) {
      dispatch(login(accessToken));
      navigate("/dashboard");
      toast.success("Login successful");
    } else {
      navigate("/login");
    }
  }, [location, navigate, dispatch]);

  return (
    <div className="w-screen h-screen flex justify-center items-center ">
      <PacmanLoader speedMultiplier={2} />
    </div>
  );
}

export default AuthCallback;
